<template>
  <div :class="['home', {'is-flag': $flag}]">
    <!-- Hero Section -->
    <div class="hero-section">
      <div class="container hero-content">
        <div class="hero-text">
          <h1 class="hero-title">致力于提高医疗<br />机构数字化</h1>
          <p class="hero-subtitle">以客户需求为己任，不断创新，为不同客户提供更加具有性价比的医疗产品服务</p>
          <div class="hero-btns">
            <el-button type="primary" size="large" @click="$router.push('/ProductCenter')">了解我们的产品</el-button>
            <el-button size="large" @click="$router.push('/AboutUs')">关于我们</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Industry Advantages -->
    <section class="section industry-section">
      <div class="container">
        <div class="section-header tc">
          <h2 class="section-title">行业优势</h2>
          <p class="section-subtitle">INDUSTRY ADVANTAGES</p>
          <div class="title-line"></div>
        </div>
        
        <div class="industry-grid">
          <div class="industry-card" v-for="(item, index) in industry" :key="index">
            <div class="card-icon">
              <img :src="item.image" :alt="item.txt" />
            </div>
            <h3 class="card-title">{{ item.txt }}</h3>
            <p class="card-desc">提供专业化、标准化的医疗数字化解决方案，助力行业升级。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Core Products -->
    <section class="section core-section">
      <div class="container">
        <div class="section-header tc">
          <h2 class="section-title">核心产品</h2>
          <p class="section-subtitle">CORE PRODUCTS</p>
          <div class="title-line"></div>
        </div>

        <div class="core-layout">
          <div class="core-nav">
            <div 
              v-for="(item, index) in core" 
              :key="index" 
              class="core-nav-item"
              :class="{ 'active': activeName === index }"
              @mouseenter="activeName = index"
            >
              <span class="nav-number">0{{ index + 1 }}</span>
              <span class="nav-text">{{ item.txt }}</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          
          <div class="core-display">
            <transition name="fade-transform" mode="out-in">
              <div :key="activeName" class="product-detail">
                <div class="product-info">
                  <h3 class="product-name">{{ core[activeName].txt }}</h3>
                  <div class="product-desc" v-html="core[activeName].desc"></div>
                  <el-button type="text" class="learn-more" @click="$router.push('/ProductCenter')">
                    查看详情 <i class="el-icon-right"></i>
                  </el-button>
                </div>
                <div class="product-image">
                  <img :src="core[activeName].image" :alt="core[activeName].txt">
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </section>

    <!-- About Us Preview -->
    <section class="section about-preview">
      <div class="container">
        <div class="about-layout">
          <div class="about-text">
            <div class="section-header tl">
              <h2 class="section-title">关于我们</h2>
              <p class="section-subtitle">ABOUT US</p>
              <div class="title-line tl"></div>
            </div>
            <p class="about-p">汇图科技（浙江）有限公司于2023年05月成立，是一家以医学影像云存储、管理为基础，提供了医学影像共享、远程会诊、双向转诊、移动阅片、远程影像诊断等为核心服务的智慧医疗服务型公司。</p>
            <p class="about-p">我们致力于提高医疗机构信息化、移动化水平及跨院业务协作，为患者、医生、医疗机构提供专业医学数字影像服务。科学的将云计算、大数据、人工智能等技术与医学影像创新融合，打造“专业影像云+人工智能应用平台”。</p>
            <el-button type="primary" plain @click="$router.push('/AboutUs')">更多关于我们</el-button>
          </div>
          <div class="about-features">
            <div class="feature-item" v-for="(item, index) in about" :key="index">
              <div class="feature-icon">
                <img :src="item.image" />
              </div>
              <span class="feature-name">{{ item.txt }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
	name: 'IndexHome',
	data() {
		return {
			industry: [
				{
					image: require('../assets/images/industry-1.png'),
					txt: '服务企业'
				},
				{
					image: require('../assets/images/industry-2.png'),
					txt: '专业人才'
				},
				{
					image: require('../assets/images/industry-3.png'),
					txt: '服务终端'
				}
			],
			core: [
				{
					image: require('../assets/images/core-1.png'),
					txt: '云影像后台',
					desc: '<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;医学云影像服务作为云端系统，主要用于医学机构、学术组织及医院间的存储、共享以及医学图像的处理，它可以让用户获取医学影像数据、加强医疗机构间的协作、共享患者的医学影像检查结果。</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;多维度影像处理工具(窗宽窗位、测量、标注等)、MPR、三维建模支持虚拟切割，实现精准辅助诊断。</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;自定义新增编辑诊断模版，一键填充报告模板，通过云影像平台传输给患者。</p>'
				},
				{
					image: require('../assets/images/core-2.png'),
					txt: '云影像小程序',
					desc: '<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;患者在做X线检查、CT、磁共振等影像检查后，可通过二维码扫描在手机、iPad、电脑等终端，随时随地查看、下载或分享影像数据。医生能够快速在终端上，随时随地查看患者的的影像、书写报告、审核报告、速调阅患者的历史检查。</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;云影像获取方式支持短信、微信公众号、小程序、APP、报告嵌入二维码多种方式，根据医院需要自定义影像调阅配置。</p>'
				},
				{
					image: require('../assets/images/core-3.png'),
					txt: 'SAAS运营后台',
					desc: '<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;可视化影像上传数据显示，直观掌握院内影像统计信息，清晰可追溯的检查任务列表，集成患者影像数据，基于不同场景自主对患者影像、报告进行补录、新增操作。</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过实时监测，智能预警报警，灵活出警调度，事件溯源管理等方式，全面提升项目运维能力，形成“日常监管—事前预警—事中处置—事后评估”的闭环管理模式。</p>'
				}
			],
			about: [
				{
					image: require('../assets/images/about-1.png'),
					txt: '医学影像共享'
				},
				{
					image: require('../assets/images/about-2.png'),
					txt: '远程会诊'
				},
				{
					image: require('../assets/images/about-3.png'),
					txt: '双向转诊'
				},
				{
					image: require('../assets/images/about-4.png'),
					txt: '移动阅片'
				}
			],
			activeName: 0
		};
	},
    methods: {
      handleChange(val) {
        console.log(this.$flag);
		if (!val) {
			this.activeName = 0;
		}
      }
    }
};
</script>

<style lang="less" scoped>
@import '../assets/css/home.less';
</style>
